import React, {useState} from "react"
import {Form} from "antd"
import {Field, Formik, FormikValues} from "formik"
import useTranslation from 'next-translate/useTranslation'

// Components
import {Input} from "../../../../../../components/createFormItem"
import Button from "../../../../../../components/Button"
import SpecializationSelect from "../SpecializationSelect"
import AuthFormPlate from "../../../../components/AuthFormPlate"
import RoleSelect from "../RoleSelect"

// Models
import {SignUpFormProps} from "./index"

// Constants
import {Role} from "../../../../../../constants"

const SignUpForm = (props: SignUpFormProps) => {
    const {
        className,
        loading,
        onSubmit,
        utils: {
            validateEmail,
            validateFirstName,
            validateLastName,
            validatePassword,
            validateConfirmPassword,
        },
    } = props;
    const maxSteps = 3;
    const firstStep = 1;
    const [step, setStep] = useState(firstStep)
    const [specialization, setSpecialization] = useState(null)
    const [role, setRole] = useState(Role.DOCTOR)
    const { t } = useTranslation();

    const handleFormSubmit = (values: FormikValues) => {
        const {confirm, ...other} = values;

        onSubmit({...other, role});
    }

    const handleContinue = () => {
        if (step < maxSteps) {
            setStep(step + 1);
        } else {
            setStep(maxSteps)
        }
    }

    const handleBack = () => {
        if (step > firstStep) {
            setStep(step - 1)
        } else {
            setStep(firstStep)
        }
    }

    if (step === firstStep) {
        return (
            <RoleSelect
                handleContinue={handleContinue}
                handleSelect={setRole}
                selected={role}
            />
        )
    }

    if (step === 2 && role === Role.DOCTOR) {
        return (
            <SpecializationSelect
                handleContinue={handleContinue}
                handleSelect={setSpecialization}
                selected={specialization}
                handleBack={handleBack}
            />
        )
    }

    return (
        <AuthFormPlate
            title={t('common:auth.sign_up')}
            description={t('common:auth.enter_your_details_below')}
            handleBack={handleBack}
        >
            <Formik
                onSubmit={handleFormSubmit}
                initialValues={{email: "", password: "", confirm: "", firstname: "", lastname: ""}}
            >
                {({handleSubmit, isValid, values}) => (
                    <Form onFinish={handleSubmit} className={className}>
                        <Field
                            name="email"
                            type="email"
                            placeholder={t('common:email')}
                            validate={validateEmail}
                            component={Input}
                        />
                        <div className="fields-row">
                            <Field
                                name="firstname"
                                type="default"
                                placeholder={t('common:name')}
                                validate={validateFirstName}
                                component={Input}
                            />
                            <Field
                                name="lastname"
                                type="default"
                                placeholder={t('common:surname')}
                                validate={validateLastName}
                                component={Input}
                            />
                        </div>
                        <Field
                            name="password"
                            type="password"
                            placeholder={t('common:password')}
                            validate={validatePassword}
                            component={Input}
                        />
                        <Field
                            name="confirm"
                            type="password"
                            placeholder={t('common:auth.confirm_password')}
                            validate={value => validateConfirmPassword(value, values.password)}
                            component={Input}
                        />
                        <Button
                            block
                            type="primary"
                            htmlType="submit"
                            loading={isValid && loading}
                            disabled={isValid === false}
                        >
                            {t('common:auth.sign_up')}
                        </Button>
                    </Form>
                )}
            </Formik>
        </AuthFormPlate>
    );
}

export default SignUpForm